import { cn } from '../../../lib/utils.ts'

import submarkSrc from './assets/submark-dark.webp'
import wordmarkSrc from './assets/wordmark-dark.webp'
import { logoVariants } from './logo.variants.ts'

function Logo({ variant = 'wordmark', className, 'aria-label': ariaLabel = 'Orus', ...rest }: Logo.Props) {
  if (variant === 'favicon') {
    return (
      <svg
        data-slot="logo"
        role="img"
        aria-label={ariaLabel}
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(logoVariants({ variant }), className)}
        {...rest}
      >
        <g clipPath="url(#logo-favicon-clip)">
          <path
            fill="#fff"
            d="M32 18.538c0 5.76 0 8.64-1.467 10.658a7.7 7.7 0 0 1-1.699 1.7c-2.019 1.466-4.898 1.466-10.658 1.466h-4.352c-5.76 0-8.64 0-10.658-1.467a7.7 7.7 0 0 1-1.7-1.699C0 27.177 0 24.298 0 18.538v-4.352c0-5.76 0-8.64 1.467-10.658a7.7 7.7 0 0 1 1.699-1.7C5.185.363 8.064.363 13.824.363h4.352c5.76 0 8.64 0 10.658 1.467a7.7 7.7 0 0 1 1.7 1.699C32 5.547 32 8.426 32 14.186z"
          />
          <path
            fill="#E2DCFE"
            d="M32 18.538c0 5.76 0 8.64-1.467 10.658a7.7 7.7 0 0 1-1.699 1.7c-2.019 1.466-4.898 1.466-10.658 1.466h-4.352c-5.76 0-8.64 0-10.658-1.467a7.7 7.7 0 0 1-1.7-1.699C0 27.177 0 24.298 0 18.538v-4.352c0-5.76 0-8.64 1.467-10.658a7.7 7.7 0 0 1 1.699-1.7C5.185.363 8.064.363 13.824.363h4.352c5.76 0 8.64 0 10.658 1.467a7.7 7.7 0 0 1 1.7 1.699C32 5.547 32 8.426 32 14.186z"
          />
          <path
            fill="#151318"
            d="M12.08 11.625q-3.828 3.861-4.064 12.414a1.123 1.123 0 0 0 1.132 1.147h5.864a1.18 1.18 0 0 0 1.168-1.148q.17-4.793 1.82-6.873 1.615-2.027 4.824-2.324c.631-.058 1.147-.564 1.147-1.197V8.656c0-.634-.515-1.15-1.149-1.124q-6.968.285-10.742 4.093"
          />
        </g>
        <defs>
          <clipPath id="logo-favicon-clip">
            <path fill="#fff" d="M0 .362h32v32H0z" />
          </clipPath>
        </defs>
      </svg>
    )
  }

  const src = variant === 'submark' ? submarkSrc : wordmarkSrc

  return (
    <img data-slot="logo" alt={ariaLabel} src={src} className={cn(logoVariants({ variant }), className)} {...rest} />
  )
}

namespace Logo {
  export type Props = Omit<React.HTMLAttributes<Element>, 'children'> & {
    /** Which brand mark to render. @default 'wordmark' */
    variant?: 'wordmark' | 'submark' | 'favicon'
  }
}

export { Logo, logoVariants }
